// extracted by mini-css-extract-plugin
export default {"Label":"DoF3okOd3pVUcX8rFyTH"};